import CreateSlideView from "@features/media-academy/view/create-slide-view";

const CreateSlide = () => {
  return <CreateSlideView />;
};

export default CreateSlide;
